import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/common/Button";
import { servicesData } from "../data/servicesData";
import "./Services.css";
import useDocumentTitle from "../hooks/useDocumentTitle";

const Services = () => {
  useDocumentTitle("Services");

  return (
    <main className="services-page">
      <div className="container">
        <section className="services-grid-full" aria-label="Our services">
          {servicesData.map((service) => (
            <article key={service.id} className="service-card-full">
              <div className="service-content">
                <h2>{service.title}</h2>

                <p className="service-description">{service.description}</p>

                {service.features?.length > 0 && (
                  <div className="service-features">
                    <h3>Key Features</h3>

                    <ul>
                      {service.features.map((feature, index) => (
                        <li key={`${service.id}-feature-${index}`}>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="service-footer">
                  {service.price && (
                    <span className="service-price">{service.price}</span>
                  )}

                  <Link to="/contact">
                    <Button variant="primary" size="medium">
                      Inquire Now
                    </Button>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </section>

        <section className="process-section">
          <div className="process-header">
            <h2>Our Process</h2>
            <p>
              From the initial idea to final delivery, we follow a structured
              approach to each project.
            </p>
          </div>

          <div className="process-steps">
            <article className="step">
              <div className="step-number" aria-hidden="true">
                1
              </div>
              <h3>Discovery</h3>
              <p>
                We understand your goals, audience, message, and project
                requirements.
              </p>
            </article>

            <article className="step">
              <div className="step-number" aria-hidden="true">
                2
              </div>
              <h3>Planning</h3>
              <p>
                We develop the creative direction, production plan, and
                requirements for the project.
              </p>
            </article>

            <article className="step">
              <div className="step-number" aria-hidden="true">
                3
              </div>
              <h3>Production</h3>
              <p>
                We bring the planned concept to life through professional
                filming, editing, and production.
              </p>
            </article>

            <article className="step">
              <div className="step-number" aria-hidden="true">
                4
              </div>
              <h3>Delivery</h3>
              <p>
                We finalize and deliver the completed content according to the
                agreed project requirements.
              </p>
            </article>
          </div>
        </section>

        <section className="services-cta">
          <h2>Have a Project in Mind?</h2>
          <p>
            Let's discuss your requirements and how we can help bring your
            project to life.
          </p>

          <Link to="/contact">
            <Button variant="primary" size="large">
              Get In Touch
            </Button>
          </Link>
        </section>
      </div>
    </main>
  );
};

export default Services;
